import type { CareRequest } from '../hooks/useCareRequests';

function esc(val: string | null | undefined): string {
  if (val === null || val === undefined) return '';
  const str = String(val);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${day} ${h}:${min}`;
}

export function exportCsv(rows: CareRequest[]): void {
  const HEADERS = [
    '접수번호', '접수시간', '간병인등록번호',
    '간병인성명', '간병인연락처', '간병인생년월일', '간병인성별', '간병인주소',
    '환자성명', '환자연락처', '환자생년월일', '환자성별', '환자주소',
    '가입보험사', '설계사연락처', '상태', '중복',
  ];

  const csvRows = rows.map((r) => [
    esc(r.receipt_number),
    esc(formatDate(r.receipt_time)),
    esc(r.caregiver_reg_number),
    esc(r.caregiver_name),
    esc(r.caregiver_phone),
    esc(r.caregiver_birth),
    esc(r.caregiver_gender),
    esc(r.caregiver_address),
    esc(r.patient_name),
    esc(r.patient_phone),
    esc(r.patient_birth),
    esc(r.patient_gender),
    esc(r.patient_address),
    esc(r.insurance_company),
    esc(r.agent_phone),
    esc(r.status),
    esc(r.is_duplicate ? '중복' : ''),
  ].join(','));

  const bom = '\uFEFF';
  const csv = bom + [HEADERS.join(','), ...csvRows].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const now = new Date();
  const filename = `care_requests_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}.csv`;

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
